// extracted by mini-css-extract-plugin
export default {"FixedHeader":"Header-module__FixedHeader__zm7cb"};